/*
 * @Author: Marte
 * @Date:   2017-07-11 17:50:54
 * @Last Modified by: tanyaohua
 * @Last Modified time: 2020-06-08 16:49:14
 */

'use strict';

angular.module('tCreateUserModule', [])
    .controller('tCreateUserCtrl', ['$scope', '$q', '$timeout', '$element', '$modalInstance', 'modalDialog', 'trsHttpService', '$validation',
        function($scope, $q, $timeout, $element, $modalInstance, modalDialog, trsHttpService, $validation) {
            initStatus();
            initData();

            /**
             * [initStatus description]初始化状态
             *
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.status = {
                    isDate: false,
                    // whichTabShow: whichTabShow,
                    whichTabShow: 0,
                    items: [],
                    allCheckFlag: false, // 全选
                    tmyFlag: false, // 新疆维吾尔自治区媒体云平台是否全选
                    selectTMYFlag: false, // 5 新疆维吾尔自治区媒体云平台是否显示
                    arrAll: [],
                    allTimeArr: [], // 最终提交的数组
                    newDate: new Date(),
                    wangchaShow: false,
                    // 第一次到第五步亲需要初始化，后面在进入就不需要执行的一个锁
                    gotoLastFlag: true,
                };
                $scope.data = {
                    PROVINCE: '',
                    CITY: '',
                    COUNTY: '',
                    MOBILE: '',
                    isOpenWangcha: 2,
                    
                };
                $scope.customConfig2 = {
                    drops: 'up', // 弹框方向
                };
                $scope.notSame = false;
                getTenantTypes();
            }

            /**
             * [setDefaultTime description]设置默认时间 从今天到明年的今天
             *
             * @return  {[type]}  [return description]
             */
            function setDefaultTime() {
                let Da = new Date();
                var y = Da.getFullYear() + 1;
                var ya = Da.getFullYear() ;
                var m = (Da.getMonth() + 1) >= 10 ? (Da.getMonth() + 1) : '0' + (Da.getMonth() + 1);
                var d = (Da.getDate()) >= 10 ? (Da.getDate()) : '0' + (Da.getDate());
                $scope.data.today = ya + '-' + m + '-' + d; 
                $scope.data.nextYearToday = y + '-' + m + '-' + d; 
                $scope.data.STARTTIME = $scope.data.today;
                $scope.data.ENDTIME = $scope.data.nextYearToday;
            }

            /**
             * [getTenantTypes description]获取行业类型
             *
             * @return  {[type]}  [return description]
             */
            function getTenantTypes() {
                var params = {
                    serviceid: 'mlf_tenant',
                    methodname: 'findIndustryByConfig',
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    $scope.status.tenantTypes = (function() {
                        var array = [];
                        for (var i = 0; i < data.length; i++) {
                            array.push({ name: data[i], value: data[i], });
                        }
                        return array;
                    })();
                    $scope.status.selectedTenantType = angular.copy($scope.status.tenantTypes[0]);
                    $scope.data.TYPE = $scope.status.selectedTenantType.value;
                });
                setDefaultTime();
            }

            /**
             * [initData description]获取勾选items数据
             *
             * @return  {[type]}  [return description]
             */
            function initData() {
                let deffer = $q.defer();
                let params = {
                    'serviceid': 'mlf_billing',
                    'methodName': 'queryBillingModules',
                    'Status': 1,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'GET').then(function(result) {
                    if (result && result.length) {
                        result.forEach((item) => {
                            item.value = 0;
                            if (item.CHILDREN) {
                                item.CHILDREN.forEach((itm) => {
                                    itm.value = 0;
                                });
                            }
                        });
                        $scope.status.items = result;
                    }
                    deffer.resolve();
                });
                return deffer.promise;
            }
            $scope.test = function () { };
            
            /**
             * [selectTenantType description] 选择行业类型
             *
             * @return  {[type]}  [return description]
             */
            $scope.selectTenantType = function() {
                $scope.data.TYPE = $scope.status.selectedTenantType.value;
            };

            /**
             * [confirm description]确认密码是否一致
             */
            // $scope.checkPwd = function() {
            //     // if($scope.data.PASSWORD2==""){
            //     //    $scope.notSame=false;
            //     //    return;
            //     // };
            //     if ($scope.data.PASSWORD2 !== $scope.data.PASSWORD) {
            //         $scope.notSame = true;
            //     } else {
            //         $scope.notSame = false;
            //     }
            // };

            /**
             * [confirm description]提交数据
             *
             * @return  {[type]}  [return description]
             */ 
            $scope.confirm = function() {
                finalValidate().then(function() {
                    if ($scope.repeatNum) {
                        modalDialog.alertType('创建失败', '管理员手机号已被注册请更换', 'warning', false);
                        return;
                    }
                    // if ($scope.data.PASSWORD !== $scope.data.PASSWORD2) {
                    //     modalDialog.alertType("两次输入密码不一致，请重新输入", "", "warning", false);
                    //     return;
                    // }
                    $scope.data.MOBILE = $scope.data.areacode + '-' + $scope.data.telephone;
                    delete $scope.data.areacode;
                    delete $scope.data.telephone;
                    $scope.dataCopy = angular.copy($scope.data);
                    $scope.dataCopy.BillingModules = angular.copy($scope.status.allTimeArr);
                    // delete $scope.dataCopy.PASSWORD2;
                    var startTime = new Date($scope.data.STARTTIME);
                    $scope.dataCopy.STARTTIME = startTime.getFullYear() + '-' + (startTime.getMonth() + 1) + '-' + startTime.getDate();
                    var endTime = new Date($scope.dataCopy.ENDTIME);
                    $scope.dataCopy.ENDTIME = endTime.getFullYear() + '-' + (endTime.getMonth() + 1) + '-' + endTime.getDate();
                    $modalInstance.close($scope.dataCopy);

                });
            };

            /**
             * [toSecond description]进入第二部
             *
             * @return  {[type]}  [return description]
             */
            $scope.toSecond = function() {
                var deffer = $q.defer();
                $validation.validate($scope.firstForm).success(function() {
                    if ($scope.data.isOpenWangcha == 2) {
                        $scope.status.wangchaShow = true;
                        modalDialog.alertType('请检查填写项!', '', 'warning', false);
                        return;
                    }
                    if ($scope.status.tenantNameRepeat) {return;}
                    $scope.status.whichTabShow = 1;
                    var $body = $element.find('.body');
                    $body.animate({
                        scrollTop: $body.offset().top - 250,
                    });
                    deffer.resolve();
                }).error(function() {
                    $scope.status.wangchaShow = true;
                    modalDialog.alertType('请检查填写项!', '', 'warning', false);
                    $scope.status.whichTabShow = 0;
                    $timeout(function() {
                        angular.invalidPosition($scope.firstForm, $element);
                        deffer.reject();
                    });
                });
                return deffer.promise;
            };

            /**
             * [toThird description] 进入第三部
             * @return {[type]} [description]
             */
            $scope.toThird = function() {
                var deffer = $q.defer();
                $validation.validate($scope.secondForm).success(function() {
                    $scope.status.whichTabShow = 2;
                    var $body = $element.find('.body');
                    $body.animate({
                        scrollTop: $body.offset().top - 250,
                    });
                    deffer.resolve();
                }).error(function() {
                    modalDialog.alertType('请检查填写项!', '', 'warning', false);
                    $scope.status.whichTabShow = 1;
                    $timeout(function() {
                        angular.invalidPosition($scope.secondForm, $element);
                        deffer.reject();
                    });
                });
                return deffer.promise;
            };

            /** 
             *[toThird description] 进入第四步
             * @return {[type]} [description]
             */
            $scope.toFourth = function() {
                var deffer = $q.defer();
                if ($scope.status.emailRepeat) {
                    $timeout(function() {
                        $scope.status.whichTabShow = 2;
                        modalDialog.alertType('请检查填写项!', '', 'error', false);
                        deffer.reject();
                    });
                    return deffer.promise;
                }
                $validation.validate($scope.thirdForm).success(function() {
                    $scope.status.whichTabShow = 3;
                    deffer.resolve();
                }).error(function() {
                    modalDialog.alertType('请检查填写项!', '', 'error', false);
                    $scope.status.whichTabShow = 2;
                    $timeout(function() {
                        angular.invalidPosition($scope.firstForm, $element);
                        deffer.reject();
                    });
                });
                return deffer.promise;
            };

            /** 
             *[toThird description] 进入第五步
             * @return {[type]} [description]
             */
            $scope.toFifth = function() {
                var deffer = $q.defer();
                $validation.validate($scope.fourForm).success(function() {
                    $scope.gotoLast();
                    deffer.resolve();
                }).error(function() {
                    modalDialog.alertType('请检查填写项!', '', 'error', false);
                    $scope.status.whichTabShow = 3;
                    $timeout(function() {
                        angular.invalidPosition($scope.firstForm, $element);
                        deffer.reject();
                    });
                });
                return deffer.promise;
            };

            /**
             * [finalValidate description] 最终校验
             * @return {[type]} [description]
             */
            function finalValidate() {
                var deffer = $q.defer();
                $scope.toSecond().then(() => $scope.toThird()).then(() => $scope.toFourth()).then(() => $scope.toFifth()).then(function() {
                    $validation.validate($scope.fiveForm).success(function() {
                        detectTimeArr();
                        deffer.resolve();
                    }).error(function() {
                        modalDialog.alertType('请检查填写项!', '', 'error', false);
                        $scope.status.whichTabShow = 4;
                        $timeout(function() {
                            angular.invalidPosition($scope.firstForm, $element);
                            deffer.reject();
                        });
                    });
                });
                return deffer.promise;
            }

            $scope.$watch('data.USERPHONE', function() {
                if ($scope.data.USERPHONE != '' && $scope.data.USERPHONE !== undefined) {
                    var params = {
                        serviceid: 'mlf_usermanagement',
                        methodname: 'checkUserPhone',
                        PHONENUMBER: $scope.data.USERPHONE,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        if (data.TYPE != '3') {
                            $scope.repeatNum = true;
                        } else {
                            $scope.repeatNum = false;
                        }
                    });
                }
                if ($scope.data.USERPHONE === '') {
                    $scope.repeatNum = false;
                }
            });
            // 取消
            $scope.cancel = function() {
                $modalInstance.dismiss();
            };

            /**
             * [allCheckFn description]全部选中
             *
             * @return  {[type]}  [return description]
             */
            $scope.allCheckFn = function () {
                $scope.status.gotoLastFlag = true;
                if ($scope.status.allCheckFlag) {
                    selectChangeFn($scope.status.items, 0);
                    $scope.status.allCheckFlag = false;
                } else {
                    selectChangeFn($scope.status.items, 1);
                    $scope.status.allCheckFlag = true;
                }
                checkTMYselectAll();
            };

            /**
             * [selectChangeFn description]
             *
             * @param   {[type]}  items              [items description] number 要改成的值, name 特定的类别改值
             * @param   {[type]}  value              [value description]
             * @param   {[type]}  BILLINGMODULENAME  [BILLINGMODULENAME description]
             *
             * @return  {[type]}                     [return description]
             */
            function selectChangeFn(items, value, BILLINGMODULENAME) {
                items.forEach((item) => {
                    if (item.CHILDREN) {
                        selectChangeFn(item.CHILDREN, value, BILLINGMODULENAME);
                    } else {
                        if (BILLINGMODULENAME) {
                            if (item.BILLINGMODULENAME == BILLINGMODULENAME) {
                                item.value = value;
                            }
                        } else {
                            item.value = value;
                        }
                    }
                });
            }

            /**
             * [itemCheckAll description]数组中的某一个子数组 全选
             *
             * @param   {[type]}  index  [index description]
             *
             * @return  {[type]}         [return description]
             */
            $scope.itemCheckAll = function(index) {
                var items = $scope.status.items[index].CHILDREN;
                if (items) {
                    var checkAll = items.find((item) => item.value == 0);
                    if (checkAll == undefined) {
                        selectChangeFn(items, 0);
                    } else {
                        selectChangeFn(items, 1);
                    }
                    $scope.status.tmyFlag = !(checkAll == undefined);
                }
                checkAllSelect();
            };

            /**
             * [checkTMYselectAll description]检查新疆维吾尔自治区媒体云平台 子数组是否是全选
             *
             * @return  {[type]}  [return description]
             */
            function checkTMYselectAll() {
                var items = $scope.status.items[0].CHILDREN;
                var checkAll = items.find((item) => item.value == 0);
                $scope.status.tmyFlag = checkAll == undefined;
            }

            /**
             * [checkAllSelect description]检查所有的元素是不是选中
             *
             * @return  {[type]}  [return description]
             */
            function checkAllSelect() {
                $scope.status.arrAll = [];
                turnArr($scope.status.items);
                var checkAll = $scope.status.arrAll.find((item) => item.value == 0);
                $scope.status.allCheckFlag = checkAll == undefined;
            }

            /**
             * [turnArr description]
             *
             * @param   {[type]}  items  [items description]
             *
             * @return  {[type]}         [return description]
             */
            function turnArr(items) {
                $scope.status.gotoLastFlag = true;
                items.forEach((item) => {
                    if (item.CHILDREN) {
                        turnArr(item.CHILDREN);
                    } else {
                        $scope.status.arrAll.push(item);
                    }
                });
            }

            /**
             * [itemCheck description]数组item 单个点击选中
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
            $scope.itemCheck = function(item) {
                if (item.value == 1) {
                    selectChangeFn($scope.status.items, 0, item.BILLINGMODULENAME);
                } else {
                    selectChangeFn($scope.status.items, 1, item.BILLINGMODULENAME);
                }
                $scope.status.gotoLastFlag = true;
                checkTMYselectAll();
                checkAllSelect();
            };

            /**
             * [detectTimeArr description]检出 allTimeArr 数组,提交数据用到
             *
             * @return  {[type]}  [return description]
             */
            function detectTimeArr() {
                $scope.status.allTimeArr = [];
                $scope.status.items.forEach((item) => {
                    if (item.CHILDREN) {
                        item.CHILDREN.forEach((itm) => {
                            if (itm.value == 1) {
                                var obj = {
                                    'BillingModuleId': itm.BILLINGMODULEID,
                                    'StartTime': itm.STARTTIME,
                                    'EndTime': itm.ENDTIME,
                                    'ParentId': itm.PARENTID,
                                    'Remarks': itm.NOTES ? itm.NOTES : '',
                                    'UseDetailedList': '-',
                                    'TenantId': '',
                                };
                                $scope.status.allTimeArr.push(obj);
                            }
                        });
                    } else {
                        if (item.value == 1) {
                            var obj = {
                                'BillingModuleId': item.BILLINGMODULEID,
                                'StartTime': item.STARTTIME,
                                'EndTime': item.ENDTIME,
                                'ParentId': item.PARENTID,
                                'Remarks': item.NOTES ? item.NOTES : '',
                                'UseDetailedList': '-',
                                'TenantId': '',
                            };
                            $scope.status.allTimeArr.push(obj);
                        }
                    }
                });
            }

            /**
             * [gotoLast description]去往最后一步
             *
             * @return  {[type]}  [return description]
             */
            $scope.gotoLast = function() {
                $scope.status.whichTabShow = 4;
                $scope.status.selectTMYFlag = false;
                if ($scope.status.gotoLastFlag && $scope.status.items.length) {
                    $scope.status.items.forEach((item) => {
                        if (item.CHILDREN) {
                            item.CHILDREN.forEach((itm) => {
                                if (itm.value == 1) {
                                    // 增加默认起止时间 从今日到明年今天
                                    itm.STARTTIME = itm.STARTTIME || itm.STARTTIME === '' ? itm.STARTTIME : $scope.data.STARTTIME;
                                    itm.ENDTIME = itm.ENDTIME || itm.ENDTIME === '' ? itm.ENDTIME : $scope.data.ENDTIME;
                                    $scope.status.selectTMYFlag = true;
                                }
                            });
                        } else {
                            if (item.value == 1) {
                                item.STARTTIME = item.STARTTIME || item.STARTTIME === '' ? item.STARTTIME : $scope.data.STARTTIME;
                                item.ENDTIME = item.ENDTIME || item.ENDTIME === '' ? item.ENDTIME : $scope.data.ENDTIME;
                            }
                        }
                    });
                    $scope.status.gotoLastFlag = false;
                }
            };
        },
    ]);
